module.exports = __webpack_public_path__ + "img/facebook-logo.7a4937b0.svg";